import { Button } from '../primitives/button/button';
import { Checkbox } from '../primitives/checkbox/checkbox';
import { Input } from '../primitives/imput/input';
import { useConsentStore } from "../../../lib/store/consent-store";
import { cn } from "../../../lib/utils";
import { IMaskInput } from "react-imask";
import { useEffect, useState } from "react";
import { useSendForm } from "../../../lib/hooks/use-send-form";

const downloadPdf = () => {
  try {
    const link = document.createElement('a');
    const body = document.body;

    link.setAttribute("href", '/docs/ЖК_КРЕКШИНО_ПАРК_ПРЕЗЕНТАЦИЯ.pdf');
    link.setAttribute("download", 'ЖК_КРЕКШИНО_ПАРК_ПРЕЗЕНТАЦИЯ.pdf');
    link.style.display = 'none';

    body.appendChild(link);

    link.click();

    body.removeChild(link);
  } catch (error) {
    if (error instanceof Error) {
      console.error(error.message);
    }
  }
};

export const PresentationForm = () => {
  const consent = useConsentStore(state => state.consent);
  const updateConsent = useConsentStore(state => state.updateConsent);

  const [termsChecked, setTermsChecked] = useState(false);
  const [termsError, setTermsError] = useState(false)
  const [fieldsError, setFieldsError] = useState(false)

  const [success, setSuccess] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    text: 'Получить презентацию'
  })

  useEffect(() => {
    setFieldsError(false)
  }, [formData])

  useEffect(() => {
    setTermsError(false)
  }, [termsChecked]);

  const handleInputChange = (value: string, name: string) => {
    setFormData({ ...formData, [name]: value })
  }

  const validateFormAndSend = () => {
    if (formData.name === '' || formData.phone === '') {
      setFieldsError(true)
      return
    }

    if (formData.phone !== '') {
      const cleaned = formData.phone.replace(/\D/g, '');
      const isDigitsOnly = /^\d+$/.test(cleaned);
      const isValidLength = cleaned.length >= 10 && cleaned.length <= 15;

      if (isDigitsOnly && isValidLength) {

      } else {
        setFieldsError(true)
        return
      }
    }

    if (!termsChecked) {
      setTermsError(true)
      return
    }

    sendForm(formData, 'getPresentation', () => {
      setSuccess(true)
      downloadPdf();

    });

  }

  const { sendForm, isPending, error } = useSendForm()

  return (
    <section className="mt-16 font-open-sans screen-900:mt-5">
      <div className="max-w-[1020px] w-full px-5 mx-auto screen-900:px-0">
        <div
          className="py-10 px-[100px] bg-plt-black rounded-[60px] screen-900:rounded-none screen-900:px-5 screen-700:py-5">
          <h3 className="text-[32px] text-plt-white font-bold text-center uppercase screen-700:text-lg">
            Получить презентацию
          </h3>
          <div className="grid grid-cols-3 gap-5 mt-10 screen-700:grid-cols-1 screen-700:gap-2 screen-700:mt-5">
            <Input
              value={formData.name}
              onChange={e => handleInputChange(e.target.value, 'name')}
              placeholder="Ваше имя"
              className="bg-plt-white h-[60px] placeholder:font-semibold placeholder:text-[#5F5357] rounded-xl screen-700:h-10"
            />
            <IMaskInput
              value={formData.phone}
              onAccept={value => handleInputChange(value, 'phone')}
              mask={'+7 (000) 000-00-00'}
              placeholder={'Ваш телефон'}
              className={cn(
                'ym-record-keys placeholder:text-plt-dark-gray selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-plt-gray flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                'rounded-[5px] h-8',
                'bg-plt-white h-[60px] placeholder:font-semibold placeholder:text-[#5F5357] rounded-xl screen-700:h-10'
              )} />
            <Button disabled={isPending} onClick={validateFormAndSend}
              className="h-[60px] font-semibold rounded-xl screen-700:h-10">
              Скачать
            </Button>

          </div>
          {success &&
            <p className='py-3 rounded text-center text-xs text-green-500 border border-solid border-green-500'>Форма
              успешно
              отправлена, спасибо!</p>}
          <div className='text-center'>
            {termsError &&
              <p className='text-xs text-red-500'>Пожалуйста, дайте согласие на обработку персональных данных</p>}
            {fieldsError && <p className='text-xs text-red-500'>Пожалуйста, заполните все поля перед отправкой</p>}
          </div>
          <div className="w-fit mx-auto mt-6 flex items-center gap-2">
            <Checkbox
              checked={termsChecked}
              onCheckedChange={(checked) => setTermsChecked(checked === true)}
              id="terms-presentation"
              className="bg-plt-white rounded-[2px]"
            />
            <label
              htmlFor="terms-presentation"
              className="text-xs text-plt-white screen-700:text-[#989898]"
            >
              Нажимая «Скачать», вы даете согласие на обработку персональных
              данных и соглашаетесь с политикой конфиденциальности{' '}
            </label>
          </div>
          <div className="w-fit mx-auto mt-2 flex items-center gap-2">
            <Checkbox id={'consent'} checked={consent} onCheckedChange={(checked) => updateConsent(checked === true)}
              className="bg-plt-white rounded-[2px]" />
            <label className="text-xs text-plt-white screen-700:text-[#989898]" htmlFor='consent'>
              Я ознакомлен (-на) с правилами обработки куки
            </label>
          </div>
        </div>
      </div>
    </section>
  );
};
